export const chapter4Translations = {
  name: "Rozdział 4: Ukrzyżowanie i Zmartwychwstanie",
  description: "Śledź historię męki, śmierci i zmartwychwstania Jezusa",
  spiritualWisdom: "Krzyż jest symbolem ostatecznego triumfu miłości i zwycięstwa nad grzechem. Zmartwychwstanie daje nam obietnicę nowego życia w Chrystusie.",
  
  levels: {
    40: {
      name: "Aresztowanie",
      challenge: "Dowiedz się o aresztowaniu Jezusa w Ogrójcu",
      
      questions: {
        easy: {
          question: "W jakim ogrodzie został aresztowany Jezus?",
          options: ["Getsemani", "Eden", "Oliwny", "Nazaret"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "Jakiego znaku użył Judasz, aby zdradzić Jezusa?",
          options: ["Uścisk dłoni", "Pocałunek", "Słowo", "Gest"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Który uczeń odciął mieczem ucho sługi arcykapłana?",
          options: ["Jakub", "Jan", "Piotr", "Andrzej"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Getsemani to ogród u podnóża Góry Oliwnej",
        "Judasz zdradził Jezusa za 30 srebrników",
        "Jezus cudownie uzdrowił ucho sługi"
      ],
      
      funFacts: [
        "Getsemani oznacza 'tłocznia', gdzie produkowano oliwę z oliwek",
        "Aresztowanie Jezusa miało miejsce w środku nocy",
        "Jezus poszedł pokojowo, prosząc uczniów, aby nie stawiać oporu przemocą"
      ]
    },

    41: {
      name: "Zaparcie się Piotra",
      challenge: "Dowiedz się, jak Piotr trzykrotnie zaparł się Jezusa",
      
      questions: {
        easy: {
          question: "Ile razy Piotr zaparł się Jezusa?",
          options: ["Raz", "Dwa razy", "Trzy razy", "Cztery razy"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Co się stało po trzecim zaparciu się Piotra?",
          options: ["Wzeszło słońce", "Zapiał kogut", "Błysnęła błyskawica", "Nastąpiło trzęsienie ziemi"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Gdzie był Piotr, gdy zaparł się Jezusa?",
          options: ["W świątyni", "Na dziedzińcu arcykapłana", "W pałacu Piłata", "W Getsemani"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Jezus przepowiedział zaparcie się Piotra",
        "Piotr gorzko płakał po uświadomieniu sobie, co zrobił",
        "Wszystko wydarzyło się tej samej nocy"
      ],
      
      funFacts: [
        "Jezus powiedział 'Zanim kogut zapieje, trzy razy się Mnie wyprzesz'",
        "Zaparcie się Piotra jest potężnym przykładem ludzkiej słabości i Bożego przebaczenia",
        "Piotr później stał się wielkim przywódcą Kościoła"
      ]
    },

    42: {
      name: "Jezus przed Piłatem",
      challenge: "Dowiedz się o procesie Jezusa przed rzymskim namiestnikiem",
      
      questions: {
        easy: {
          question: "Kim był Piłat?",
          options: ["Uczniem", "Rzymskim namiestnikiem", "Arcykapłanem", "Faryzeuszem"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Czego nie znalazł Piłat w Jezusie?",
          options: ["Mądrości", "Winy", "Odwagi", "Mocy"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Co zrobił Piłat, aby symbolizować swoją niewinność?",
          options: ["Umył ręce", "Rozdarł szatę", "Pościł", "Modlił się"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Piłat chciał uwolnić Jezusa",
        "Tłum domagał się ukrzyżowania Jezusa",
        "Piłat uległ naciskom politycznym"
      ],
      
      funFacts: [
        "Żona Piłata ostrzegła go, aby nic nie czynił przeciw Jezusowi",
        "Umycie rąk było symbolem niewinności w tradycji żydowskiej",
        "Decyzja Piłata pokazała porażkę ludzkiej sprawiedliwości"
      ]
    },

    43: {
      name: "Barabasz czy Jezus",
      challenge: "Dowiedz się o wyborze tłumu na rzecz Barabasza",
      
      questions: {
        easy: {
          question: "Kim był Barabasz?",
          options: ["Uczniem", "Zbrodniarzem", "Kapłanem", "Królem"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Co mógł zrobić Piłat podczas żydowskiego święta?",
          options: ["Uwolnić jednego więźnia", "Wybaczyć podatki", "Urządzić ucztę", "Zamknąć świątynię"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Kogo wybrał tłum?",
          options: ["Jezusa", "Barabasza", "Obu", "Nikogo"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "To było święto Paschy",
        "Tłum domagał się ukrzyżowania Jezusa",
        "Barabasz był mordercą i buntownikiem"
      ],
      
      funFacts: [
        "Imię Barabasz oznacza 'syn ojca'",
        "Uwolnienie Barabasza jest symbolem ofiary Chrystusa",
        "Wszyscy jesteśmy Barabaszem, uwolnionymi przez ofiarę Jezusa"
      ]
    },

    44: {
      name: "Biczowanie i Korona Cierniowa",
      challenge: "Dowiedz się o cierpieniu Jezusa",
      
      questions: {
        easy: {
          question: "Co założyli żołnierze na głowę Jezusa?",
          options: ["Złotą koronę", "Koronę cierniową", "Wieniec kwiatów", "Turban"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Jak żołnierze szydzili z Jezusa?",
          options: ["Nazywając Go królem", "Rzucając kamieniami", "Więziąc Go", "Ignorując Go"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Co zawierał rzymski bicz?",
          options: ["Skórzane paski", "Kawałki kości i metalu", "Tylko drewno", "Linę"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Biczowanie było okrutną rzymską karą",
        "Żołnierze ubrali Jezusa w purpurowy płaszcz",
        "Jezus zniósł to wszystko w milczeniu"
      ],
      
      funFacts: [
        "Korona cierniowa symbolizuje przekleństwo grzechu",
        "Purpura była kolorem królewskim, użytym na szyderstwo",
        "Cierpienie Jezusa wypełnia proroctwa Izajasza"
      ]
    },

    45: {
      name: "Droga na Golgotę",
      challenge: "Dowiedz się, jak Jezus niósł krzyż",
      
      questions: {
        easy: {
          question: "Co niósł Jezus?",
          options: ["Flagę", "Krzyż", "Koronę", "Miecz"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Kto pomógł Jezusowi nieść krzyż?",
          options: ["Piotr", "Jan", "Szymon z Cyreny", "Józef"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Co oznacza Golgota?",
          options: ["Święta góra", "Miejsce czaszki", "Miejsce pokoju", "Miejsce sprawiedliwości"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Jezus upadał z powodu słabości",
        "Kobiety płakały po drodze",
        "Procesja przeszła przez miasto"
      ],
      
      funFacts: [
        "Krzyż ważył około 40-50 kg",
        "Golgota znajdowała się poza murami miasta",
        "Szymon z Cyreny pochodził z Afryki"
      ]
    },

    46: {
      name: "Ukrzyżowanie",
      challenge: "Dowiedz się o ukrzyżowaniu Jezusa",
      
      questions: {
        easy: {
          question: "Z iloma innymi osobami został ukrzyżowany Jezus?",
          options: ["Nikim", "Jedną", "Dwiema", "Trzema"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Co Jezus powiedział na krzyżu: 'Ojcze, ___ im'?",
          options: ["Zbaw", "Przebacz", "Powstrzymaj", "Ukarać"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Jaki był napis na krzyżu?",
          options: ["Grzesznik", "Król Żydowski", "Buntownik", "Prorok"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Jezus został ukrzyżowany o trzeciej godzinie dnia",
        "Żołnierze rzucali losy o Jego szaty",
        "Jezus wypowiedział siedem słów z krzyża"
      ],
      
      funFacts: [
        "Napis był napisany w trzech językach: hebrajskim, łacińskim i greckim",
        "Jeden ze złoczyńców nawrócił się w ostatniej chwili",
        "Jezus powierzył swoją matkę opiece Jana"
      ]
    },

    47: {
      name: "Śmierć Jezusa",
      challenge: "Dowiedz się o ostatnich godzinach Jezusa",
      
      questions: {
        easy: {
          question: "Co się stało w momencie śmierci Jezusa?",
          options: ["Słońce zaświeciło jaśniej", "Nastała ciemność", "Spadł deszcz", "Pojawiła się tęcza"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Co rozdarło się w świątyni?",
          options: ["Podłoga", "Zasłona", "Ściana", "Sufit"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Jakie były ostatnie słowa Jezusa?",
          options: ["Wykonało się", "Pragnę", "Ojcze, w Twoje ręce powierzam ducha mego", "Czemuś Mnie opuścił"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Ciemność trwała trzy godziny",
        "Żołnierz przebił bok Jezusa włócznią",
        "Setnik powiedział 'Prawdziwie, ten człowiek był Synem Bożym'"
      ],
      
      funFacts: [
        "Zasłona świątyni rozdarła się od góry do dołu, nie ręką ludzką",
        "Wydarzyło się to podczas Paschy, kiedy składano baranka w ofierze",
        "Śmierć Jezusa zapłaciła za cenę grzechu"
      ]
    },

    48: {
      name: "Pogrzeb",
      challenge: "Dowiedz się o pogrzebie Jezusa",
      
      questions: {
        easy: {
          question: "W czyim grobie złożono Jezusa?",
          options: ["Piotra", "Józefa z Arymatei", "Nikodema", "Łazarza"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "W co owinięto ciało Jezusa?",
          options: ["Purpurowy płaszcz", "Złote szaty", "Białe płótno", "Bez szat"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Co przyniósł Nikodem dla ciała Jezusa?",
          options: ["Oliwę", "Mirrę i aloes", "Wodę", "Kwiaty"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Grób był wykuty w nowej skale",
        "Wielki kamień zatoczono przed wejście",
        "Straż została wystawiona, aby strzec grobu"
      ],
      
      funFacts: [
        "Był to grób bogatego człowieka, wypełniając proroctwo Izajasza",
        "Pochówek odbył się pospiesznie, bo zbliżał się szabat",
        "Józef był tajnym uczniem, który stał się odważny"
      ]
    },

    49: {
      name: "Pusty Grób",
      challenge: "Dowiedz się o odkryciu poranku zmartwychwstania",
      
      questions: {
        easy: {
          question: "Kto jako pierwszy znalazł pusty grób?",
          options: ["Piotr", "Jan", "Kobiety", "Żołnierze"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Gdzie był kamień?",
          options: ["Rozbity", "Odwalony", "Wciąż tam", "Zniknął"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Ilu aniołów spotkały kobiety w grobie?",
          options: ["Żadnego", "Jednego", "Dwóch", "Trzech"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Był to ranek pierwszego dnia tygodnia",
        "Kobiety przyszły namaścić ciało Jezusa",
        "Aniołowie ogłosili dobrą nowinę"
      ],
      
      funFacts: [
        "Kobiety były pierwszymi świadkami, co było rewolucyjnym szczegółem",
        "Piotr i Jan pobiegli do grobu",
        "Sam pusty grób nie wystarczył, Jezus musiał się ukazać"
      ]
    },

    50: {
      name: "Jezus ukazuje się Marii Magdalenie",
      challenge: "Dowiedz się o pierwszym ukazaniu się Jezusa",
      
      questions: {
        easy: {
          question: "Komu jako pierwszej ukazał się Jezus po zmartwychwstaniu?",
          options: ["Piotrowi", "Janowi", "Marii Magdalenie", "Tomaszowi"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Za kogo Maria początkowo wzięła Jezusa?",
          options: ["Anioła", "Ogrodnika", "Żołnierza", "Faryzeusza"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Co Jezus powiedział do Marii, gdy Go rozpoznała?",
          options: ["Idź i powiedz", "Nie dotykaj Mnie", "Nie bój się", "Wierz"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Maria płakała przy grobie",
        "Jezus zawołał ją po imieniu",
        "Posłał ją, aby powiedziała Jego braciom"
      ],
      
      funFacts: [
        "Jezus wybrał kobietę do swojego pierwszego ukazania się",
        "Maria stała się pierwszym apostołem",
        "Nazwała Go 'Rabbuni' (Nauczycielu)"
      ]
    },

    51: {
      name: "W drodze do Emaus",
      challenge: "Dowiedz się o ukazaniu się Jezusa na drodze",
      
      questions: {
        easy: {
          question: "Ilu uczniów szło do Emaus?",
          options: ["Jeden", "Dwóch", "Trzech", "Czterech"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Kiedy uczniowie rozpoznali Jezusa?",
          options: ["Od razu", "Przy łamaniu chleba", "Na drodze", "Nigdy"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Co Jezus wyjaśnił im po drodze?",
          options: ["Przyszłość", "Pisma", "Prawo", "Cuda"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Jezus szedł z nimi jako nieznajomy",
        "Ich serca płonęły, gdy On mówił",
        "Jezus zniknął, gdy Go rozpoznali"
      ],
      
      funFacts: [
        "Emaus było około 11 km od Jerozolimy",
        "Jezus pokazał im, jak wszystkie Pisma mówiły o Nim",
        "Uczniowie natychmiast pobiegli z powrotem do Jerozolimy"
      ]
    },

    52: {
      name: "Ukazanie się Uczniom",
      challenge: "Dowiedz się o ukazaniu się Jezusa w zamkniętym pomieszczeniu",
      
      questions: {
        easy: {
          question: "Gdzie byli uczniowie, gdy Jezus się ukazał?",
          options: ["W świątyni", "Na rynku", "W zamkniętym pomieszczeniu", "W Getsemani"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Co Jezus pokazał uczniom?",
          options: ["Swoje rany", "Swoją twarz", "Swoje szaty", "Światło"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Którego ucznia nie było za pierwszym razem?",
          options: ["Piotra", "Jana", "Tomasza", "Jakuba"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Drzwi były zamknięte ze strachu",
        "Jezus powiedział 'Pokój wam'",
        "Tchnął na nich i powiedział 'Weźmijcie Ducha Świętego'"
      ],
      
      funFacts: [
        "Jezus jadł z nimi, aby udowodnić, że nie jest duchem",
        "Tomasz uwierzył tydzień później",
        "Jezus ukazywał się wiele razy przez 40 dni"
      ]
    }
  }
};
